import script from "./HomeStar.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeStar.vue?vue&type=script&setup=true&lang=js"

import "./HomeStar.vue?vue&type=style&index=0&id=32fca042&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32fca042"]])

export default __exports__